<template>
    <button
        type="button"
        class="btn btn-round"
        :class="[
            `btn-${icon}`,
            { 'has-pulse-effect': hasPulseEffect, 'needs-consent': needsConsent, 'has-valid-consent': hasValidConsent,'has-text':hasText },
        ]"
    >
        <span class="sr-only">{{ srText }}</span>
        <svg :class="['btn-icon', `btn-icon-${icon}`]" viewBox="0 0 100 100" aria-hidden="true">
            <path :d="iconData[icon]" />
        </svg>
        <span v-if="needsConsent" class="btn-caption">Accept Vimeo Cookies</span>
        <span v-if="hasText" class="btn-caption">{{ text }}</span>
        <span v-if="hasPulseEffect" aria-hidden="true" class="circle"></span>
    </button>
</template>

<script>
    export default {
        name: 'ButtonIcon',
        props: {
            icon: String,
            srText: String,
            hasPulseEffect: {
                type: Boolean,
                default: false,
            },
            text:String,
            hasText:{
                type: Boolean,
                default: false,
            },
            needsConsent: {
                type: Boolean,
                default: false,
            },
            hasValidConsent: {
                type: Boolean,
                default: false,
            },
            consentCaption: String,
        },
        data() {
            return {
                iconData: {
                    plus2: 'M100,46H54V0H46V46H0v8H46v46h8V54h46',
                    plus: 'M100,46 54,46 54,0 46,0 46,46 0,46 0,54 46,54 46,100 54,100 54,54 100,54',
                    close: 'M100,8.5 91.5,0 50,41.5 8.5,0 0,8.5 41.5,50 0,91.5 8.5,100 50,58.5 91.5,100 100,91.5 58.5,50z',
                    arrowRight: 'M100,50L74.7,24.8v21.9H0v6.6h74.7v21.9L100,50z',
                    arrowLeft: 'M0,50l25.3,25.2V53.3H100v-6.6H25.3V24.8L0,50z',
                    play: 'M25,0 25,100 75,50',
                    microphone: 'M81.2,37.5h-3.1c-1.7,0-3.1,1.4-3.1,3.1V50c0,14.6-12.6,26.3-27.5,24.9c-13-1.3-22.5-12.9-22.5-26v-8.3c0-1.7-1.4-3.1-3.1-3.1h-3.1c-1.7,0-3.1,1.4-3.1,3.1v7.8C15.6,66,28.1,81.6,45.3,84v6.7H34.4c-1.7,0-3.1,1.4-3.1,3.1v3.1c0,1.7,1.4,3.1,3.1,3.1h31.2c1.7,0,3.1-1.4,3.1-3.1v-3.1c0-1.7-1.4-3.1-3.1-3.1H54.7V84c16.7-2.3,29.7-16.7,29.7-34v-9.4C84.4,38.9,83,37.5,81.2,37.5z M50,68.7c10.4,0,18.8-8.4,18.8-18.7V18.7C68.8,8.4,60.4,0,50,0S31.2,8.4,31.2,18.7V50C31.2,60.4,39.6,68.7,50,68.7z',
                    fingerprint: 'M77.1,4.9c1.4,0.7,2,2.4,1.3,3.8c-0.5,1-1.5,1.6-2.6,1.6c-0.4,0-0.9-0.1-1.3-0.3c-10-5.1-28.4-5.9-37-1.5c-1.4,0.7-3.1,0.1-3.8-1.2c-0.7-1.4-0.2-3.1,1.2-3.8C45-1.7,65.5-0.9,77.1,4.9z M88.1,27.3c1.1,1.1,1,2.9-0.2,4c-0.5,0.5-1.2,0.7-1.9,0.7c-0.8,0-1.5-0.4-2-0.9c-14.4-15.7-45.4-16.6-59.8-6.3c-1.2,1-3,0.7-4-0.5c-1-1.2-0.8-3,0.5-3.9c0.1,0,0.1-0.1,0.2-0.1C37.4,8.4,71.7,9.3,88.1,27.3z M53,25.5C68.7,27.2,82.1,35.8,89,48.4c0.7,1.4,0.2,3.1-1.2,3.8c-0.4,0.2-0.9,0.3-1.3,0.3c-1,0-2-0.6-2.5-1.5c-5.9-11-17.7-18.5-31.6-20C38,29.6,24.1,34.8,16.1,44.7c-1,1.2-2.8,1.4-4,0.4c-1.2-1-1.4-2.7-0.4-3.9C20.9,29.8,36.7,23.8,53,25.5z M52.8,36.6c14.6,1.8,29,15.6,31.3,30.2c0.3,1.5-0.8,3-2.3,3.2l-0.4,0.1c-1.4,0-2.6-1-2.8-2.4c-2-12.1-14.3-24-26.4-25.5c-16.3-2-31,8.5-35.9,25.4c-0.4,1.5-1.9,2.4-3.4,2c-1.5-0.4-2.4-1.9-2.1-3.4l0-0.1C16.4,46.3,33.7,34.2,52.8,36.6z M49.9,48.9c7.7,0.9,13.8,4.2,17.9,9.7c5,6.6,6.8,16.1,5.1,26.7c-0.3,1.5-1.7,2.6-3.2,2.3c-1.5-0.3-2.6-1.7-2.3-3.2c1.4-9,0-17.1-4-22.4c-3.2-4.2-7.9-6.7-14.1-7.5c-5-0.6-10,0.8-13.9,4c-4,3.2-6.5,7.9-7,13c-0.1,1.3-0.2,2.5-0.3,3.8c-0.3,4.2-0.6,8.7-3,13c-0.5,0.9-1.4,1.5-2.5,1.5c-0.5,0-1-0.1-1.4-0.4c-1.4-0.8-1.8-2.5-1.1-3.9c1.8-3.2,2-6.6,2.3-10.6c0.1-1.3,0.2-2.6,0.3-4c0.7-6.6,4-12.7,9.2-16.9C36.9,50,43.4,48.1,49.9,48.9z M48.4,59.5c7.7,1,13.3,7.7,13.1,15.4c-0.2,8.7-0.9,15.3-2.3,19.8c-0.4,1.5-2,2.3-3.5,1.9c-1.5-0.4-2.4-2-1.9-3.5c0.8-2.8,1.8-8.1,2-18.2c0.3-4.9-3.2-9.2-8-9.9c-4.7-0.5-8.8,2.9-9.3,7.5l0,0.1l0,3.3c0,4.6-0.2,12.2-4.1,19.6C33.9,96.4,33,97,31.9,97c-0.5,0-0.9-0.1-1.3-0.3c-1.4-0.7-1.9-2.4-1.2-3.8c3.6-6.7,3.5-13.7,3.4-17.9c0-1,0-1.9,0.1-2.9C33.7,64.3,40.7,58.7,48.4,59.5zM49.9,73.3c0,0.1,0.1,0.3,0.1,0.4c1.2,4.4-0.6,17.5-4,24.7c-0.5,1-1.5,1.6-2.5,1.6c-0.4,0-0.8-0.1-1.2-0.3c-1.4-0.6-2.1-2.3-1.4-3.7l0,0c3.1-6.6,4.4-18.2,3.7-20.8c-0.5-1.5,0.3-3.1,1.8-3.6C47.8,71,49.4,71.8,49.9,73.3z',
                    arrowDown:'m13.7257326 0-.0007326 7.274 7.2350037.0005079-10.4802617 10.480262-10.479742-10.480262 7.266-.0005079.00056429-7.274z'
                },
            };
        },
    };
</script>

<style scoped lang="scss">
    .btn-round {
        cursor: pointer;
        position: relative;
        display: inline-block;
        width: 60px;
        height: 60px;
        border-radius: 50%;
        background-color: #000000;
        transition: transform 0.3s, width 0.3s, background-color 0.3s;
        @include prevent-flicker();

        &.has-text{
            width: 200px;
            border-radius: 30px;
            background-color: color('magenta');

            &.has-pulse-effect .circle {
                display: none;
            }
        }
        &.needs-consent {
            width: 230px;
            border-radius: 30px;
            background-color: color('magenta');

            &.has-pulse-effect .circle {
                display: none;
            }
        }

        &.has-valid-consent {
            width: 60px;
            background-color: #000000;

            .btn-caption {
                display: none;
            }

            &.has-pulse-effect .circle {
                display: block;
            }
        }

        &.transform-to-close .btn-icon {
            transform: translate(-50%, -50%) rotate(45deg);
        }
    }

    path {
        fill: #ffffff;
        transition: fill 0.3s;
    }

    .btn-icon {
        width: 45%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        transition: transform cubic-bezier(0.175, 0.885, 0.32, 1.275) 0.2s;

        &-play {
            width: 21px;
            left: 32px;
        }
        &-plus2 {
            width: 21px;
            left: 32px;
        }

        &-microphone {
            width: 40%;
        }
        &-arrowDown{
            left: 67px;
top:67px;
}
        &-arrowLeft,
        &-arrowRight {
            width: 40%;
        }

        &-close {
            width: 35%;
        }

        &-plus {
            width: 40%;
        }
    }

    .btn-caption {
        color: #ffffff;
        font-weight: font-weight('bold');
        font-size: 16px;
        position: absolute;
        width: 100%;
        left: 10px;
        top: 50%;
        transform: translateY(-50%);
    }

    .has-pulse-effect {
        .circle {
            display: block;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) scale(1);
            transform-origin: top left;
            border-radius: 50%;
            border: 2px solid rgba(0, 0, 0, 1);
            height: 100%;
            width: 100%;
            opacity: 0;
            animation: pulsate 2s 0.3s ease-out infinite;
        }

        @keyframes pulsate {
            0% {
                transform: scale(1) translate(-50%, -50%);
                opacity: 0.8;
            }
            45% {
                transform: scale(1.5) translate(-50%, -50%);
                opacity: 0;
            }
        }
    }

    .no-touch {
        .btn-round:hover {
            transform: scale(1.25);
            &.has-text{
                transform: scale(1.1);
            }
        }

        .has-pulse-effect:hover .circle {
            animation: none;
        }
    }
</style>
